<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex mb-4>
        <h2>Please Sign In</h2>
        <v-form v-model="valid">
            <v-container>
              <v-row justify="center">
                <v-col cols="5">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    autocomplete="email"
                    required
                    @keyup.enter="signIn()"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    autocomplete="current-password"
                    hint="At least 8 characters"
                    counter
                    @click:append="show = !show"
                    @keyup.enter="signIn()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="5">
                  <v-btn @click="signIn()" color="primary" large block>Sign In</v-btn>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="5">
                <v-btn  @click="$router.push('/join-team')" small>Join The Team!</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <router-link to="password-reset" small text>Password Reset</router-link>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import db from '@/plugins/db'

export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    show: false,
    password: '',
  }),

  methods: {
    validate () { // TODO: Hookup form validation things
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async signIn () {
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function (o) {
        // Success
        let userRef = db.ref(`users/${o.user.uid}`)
        userRef.once('value').then(function (snapshot) {
          let approved = snapshot.child('approved').val()
          if (approved) {
            location.href = '/'
          } else {
            firebase.auth().signOut()
            alert('You are waiting to be approved. Please try to log in again in a few minutes.')
            location.href = '/sign-in'
          }
        })
      }).catch(function (e) {
        alert(e.message)
      })
    },
  },
}
</script>
